export default "/fonts/Nasu-Regular.ttf?f06fe3208ecbe140e3aebd3ca2725155";